










import VueOptions from '@utils/VueOptions'
import Carousel from '@ui/Carousel'

settings =
  name: "VendorListingThumbnail"

  vue:
    props: ['vendorListing', 'activationPlan', 'actions', 'options']
    components: { Carousel }

    computed:
      lineItemInfo: -> @activationPlan.line_items_info[0]

      carouselOptions: ->
        opts =
          height: '200px'
          spaceBetweenSlides: '0px'
          perPage: 1
          loop: true
          navigationPrevLabel: '<span class="flex items-center justify-center -ml-5 w-8 h-8 text-white opacity-75 hover:opacity-100 custom-text-shadow"><i class="fas fa-chevron-left text-2xl"></i></span>'
          navigationNextLabel: '<span class="flex items-center justify-center -mr-5 w-8 h-8 text-white opacity-75 hover:opacity-100 custom-text-shadow"><i class="fas fa-chevron-right text-2xl"></i></span>'
          displayGallery: false
        opts

      images: -> @vendorListing?.images || []

export default VueOptions.vue settings
